import React, { useState } from "react";
import { Topbar, Alert } from "@components";
import { useNavigate } from "react-router-dom";
import {
	ChangePinContainer,
	ChangePinTitle,
	Button,
	SubTitle,
	Form,
	Input,
	TitleWrapper,
} from "./ChangePin.style";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { openAlert } from "@redux/app/appSlice";
import { useRef } from "react";
import { useEffect } from "react";
import { GoldEye, WhiteEye } from "@assets";

const ChangePin = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);

	const [dynamicHeight, setDynamicHeight] = useState(0);
	const ref = useRef();

	useEffect(() => {
		setDynamicHeight(ref?.current?.offsetHeight);
	}, [ref]);

	const goBack = () => {
		navigate(`/${PUBLIC_ROUTE.PROFILE}`);
	};

	const onFinish = (data) => {
		if (!loading) {
			if (data.new_pin !== data.confirm_pin) {
				showAlert({
					message: t("profile.newAndConfirmPinDoNotMatch"),
					isError: true,
				});
				return;
			}
			setLoading(true);
			api
				.updatePin(data)
				.then(() => {
					setLoading(false);
					showAlert({
						message: t("common.updateSuccessMessage"),
						successCallback: goBack,
					});
				})
				.catch((errorMsg) => {
					setLoading(false);
					showAlert({
						message: errorMsg,
						isError: true,
					});
				});
		}
	};

	const showAlert = (data) => {
		dispatch(openAlert(data));
	};

	const handleKeyDown = (event) => {
		const key = event.key;
		const isAllowedKey = /^[0-9\b]+$/.test(key);
		if (!isAllowedKey && key !== "Backspace") {
			event.preventDefault();
		}
	};

	const renderEyeIcon = (visible) => (visible ? <GoldEye /> : <WhiteEye />);

	return (
		<>
			<Topbar title={t("profile.changePin")} goBack={goBack} shadow={false} />
			<ChangePinContainer>
				<TitleWrapper>
					<ChangePinTitle ref={ref}>
						{t("profile.changePinHeading")}
					</ChangePinTitle>
					<SubTitle> {t("profile.changePinSubHeading")} </SubTitle>
				</TitleWrapper>

				<Form
					layout="vertical"
					dynamicHeight={dynamicHeight}
					onFinish={onFinish}
				>
					<Form.Item
						// label={t("profile.enterOldPin")}
						name="old_pin"
						rules={[
							{
								required: true,
								message: "",
							},
							{
								pattern: /^[0-9]{6}$/,
								message: t("profile.oldPinValidateMessage"),
							},
						]}
						required={false} // Set required prop to false to remove the asterisk (*)
					>
						<Input
							type="password"
							// placeholder={t("profile.enterOldPin")}
              placeholder={t("profile.enterOldPin")}
							onKeyDown={handleKeyDown}
							iconRender={renderEyeIcon}
						/>
					</Form.Item>
					<Form.Item
						// label={t("profile.enterNewPin")}
						name="new_pin"
						rules={[
							{
								required: true,
								message: "",
							},
							{
								pattern: /^[0-9]{6}$/,
								message: t("profile.newPinValidateMessage"),
							},
						]}
						required={false}
					>
						<Input
							type="password"
							// placeholder={t("profile.enterNewPin")}
              placeholder={t("profile.enterNewPin")}
							onKeyDown={handleKeyDown}
							iconRender={renderEyeIcon}
						/>
					</Form.Item>
					<Form.Item
						// label={t("profile.enterConfirmNewPin")}
						name="confirm_pin"
						rules={[
							{
								required: true,
								message: "",
							},
							{
								pattern: /^[0-9]{6}$/,
								message: t("profile.confirmPinValidateMessage"),
							},
						]}
						required={false}
					>
						<Input
							type="password"
							// placeholder={t("profile.enterConfirmNewPin")}
              placeholder={t("profile.enterConfirmNewPin")}
							onKeyDown={handleKeyDown}
							iconRender={renderEyeIcon}
						/>
					</Form.Item>
					<Form.Item>
						<Button
							type="primary"
							size="large"
							htmlType="submit"
							loading={loading}
						>
							{t("common.save")}
						</Button>
					</Form.Item>
				</Form>
			</ChangePinContainer>
			<Alert />
		</>
	);
};

export default ChangePin;
